import React from 'react';

/**
 * Componente que muestra un mensaje visual cuando no hay resultados de búsqueda.
 * 
 * @param {Object} props
 * @param {string} props.query - El texto ingresado por el usuario en el campo de búsqueda.
 * 
 * - Si `query` está vacío, se solicita que el usuario escriba algo.
 * - Si `query` no está vacío pero no hay coincidencias, se indica que no se encontraron resultados.
 */
export default function SinResultados({ query = '' }) {
  const message =
    query.trim().length === 0
      ? 'Escriba su búsqueda arriba'
      : 'No se encontraron resultados. Intenta con otras palabras.';

  return (
    <div className="sin-resultados grid-news" role="status" aria-live="polite">
      <span className="icon-search" aria-hidden="true"></span>
      <span className="text-sin-resultados">{message}</span>
    </div>
  );
}